export enum SeoLinkGroupType {
  breadcrumb = 'breadcrumb',
  jobType = 'job_type',
  location = 'location',
  specialty = 'specialty',
}
